<template><section><h2>散点图数据更新</h2>
<block-demo tip="" source="const data = [
  {
    gender: &#39;female&#39;,
    height: 167.6,
    weight: 68.8,
  },
  {
    gender: &#39;female&#39;,
    height: 159.5,
    weight: 50.6,
  },
  {
    gender: &#39;female&#39;,
    height: 175,
    weight: 82.5,
  },
  {
    gender: &#39;female&#39;,
    height: 166.8,
    weight: 57.2,
  },
  {
    gender: &#39;male&#39;,
    height: 181.6,
    weight: 75.5,
  },
  {
    gender: &#39;male&#39;,
    height: 176.5,
    weight: 73,
  },
  {
    gender: &#39;male&#39;,
    height: 175,
    weight: 70.2,
  },
  {
    gender: &#39;male&#39;,
    height: 174,
    weight: 73.4,
  },
]

const data2 = [
  {
    gender: &#39;female&#39;,
    height: 155.8,
    weight: 53.6,
  },
  {
    gender: &#39;female&#39;,
    height: 170,
    weight: 59,
  },
  {
    gender: &#39;female&#39;,
    height: 159.1,
    weight: 47.6,
  },

  {
    gender: &#39;male&#39;,
    height: 177.8,
    weight: 64.1,
  },
  {
    gender: &#39;male&#39;,
    height: 180.3,
    weight: 83.2,
  },
  {
    gender: &#39;male&#39;,
    height: 160.3,
    weight: 83.2,
  },
]

const { Chart, Axis, Scatter, Legend, Tooltip } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;,
})
chart.source(data, {
  row: &#39;gender&#39;,
  text: &#39;height&#39;,
  value: &#39;weight&#39;,
})

const scatter = new Scatter({
  showGuideLine: true,
})

const axisBottom = new Axis()

const axisLeft = new Axis({ orient: &#39;left&#39; })

const legend = new Legend({ align: [&#39;center&#39;, &#39;bottom&#39;] })

chart.append([axisBottom, axisLeft, legend, scatter])

let count = 1
const inter = setInterval(() =&gt; {
  if (count%2 ===0) {
    chart.source(data2)
  } else {
    chart.source(data)
  }
  count+=1
}, 5000)

"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">167.6</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">68.8</span>,
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">159.5</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">50.6</span>,
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">175</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">82.5</span>,
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">166.8</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">57.2</span>,
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">181.6</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">75.5</span>,
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">176.5</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">73</span>,
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">175</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">70.2</span>,
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">174</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">73.4</span>,
  },
]

<span class="hljs-keyword">const</span> data2 = [
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">155.8</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">53.6</span>,
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">170</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">59</span>,
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">159.1</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">47.6</span>,
  },

  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">177.8</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">64.1</span>,
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">180.3</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">83.2</span>,
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">160.3</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">83.2</span>,
  },
]

<span class="hljs-keyword">const</span> { Chart, Axis, Scatter, Legend, Tooltip } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>,
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'gender'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'height'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'weight'</span>,
})

<span class="hljs-keyword">const</span> scatter = <span class="hljs-keyword">new</span> Scatter({
  <span class="hljs-attr">showGuideLine</span>: <span class="hljs-literal">true</span>,
})

<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis()

<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span> })

<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">align</span>: [<span class="hljs-string">'center'</span>, <span class="hljs-string">'bottom'</span>] })

chart.append([axisBottom, axisLeft, legend, scatter])

<span class="hljs-keyword">let</span> count = <span class="hljs-number">1</span>
<span class="hljs-keyword">const</span> inter = setInterval(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
  <span class="hljs-keyword">if</span> (count%<span class="hljs-number">2</span> ===<span class="hljs-number">0</span>) {
    chart.source(data2)
  } <span class="hljs-keyword">else</span> {
    chart.source(data)
  }
  count+=<span class="hljs-number">1</span>
}, <span class="hljs-number">5000</span>)

</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>